import { openModal, closeModal } from 'jenesius-vue-modal'
import ConfirmModal from '@/components/Modal/ConfirmModal.vue'

export default (licensesPurchased, licensesHardCap) => {
    return new Promise((resolve, reject) => {
        openModal(ConfirmModal, {
            label: 'Are you sure?',
            text: `Activating this license will exceed your organization's license\
                allotment of ${licensesPurchased} licenses and may incur additional\
                charges. At ${licensesHardCap} you will no longer be able to assign\
                additional licenses. Please contact goTenna for more information.\
                Do you want to proceed?`,
            confirm: () => {
                closeModal()
                resolve()
            },
            cancel: () => {
                closeModal()
                reject()
            },
        })
    })
}
